import React, { useMemo } from 'react';
import { DocumentHead, PageTemplate } from 'lib/components';

import { PreLoader } from './PreLoader';
import { useTranslation } from 'react-i18next';

const Wrapper = () => {
  return useMemo(() => <PreLoader />, []);
};

export const Billings = () => {
  const { t } = useTranslation();
  return (
    <>
      <DocumentHead title={t('Billing')} />
      <PageTemplate main={<Wrapper />} />
    </>
  );
};
